/** String constant for matching column IDs used in the Research Plan Details Field Table */
const COLUMN_ID_SHORT_LABEL_SAMPLE = 'sample';
const COLUMN_ID_SHORT_LABEL_REACTION = 'reaction';

export {
  COLUMN_ID_SHORT_LABEL_SAMPLE,
  COLUMN_ID_SHORT_LABEL_REACTION
};
